import { create } from 'zustand';

interface CartLoadingState {
  isGlobalCartLoading: boolean;
  startLoading: (id: string) => void;
  stopLoading: (id: string) => void;
}

let timeoutId: NodeJS.Timeout | null = null;
let activeLoadingOperations = new Set<string>();

export const useCartLoadingStore = create<CartLoadingState>((set) => ({
  isGlobalCartLoading: false,

  startLoading: (id: string) => {
    // Clear existing timeout
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    activeLoadingOperations.add(id);

    if (activeLoadingOperations.size > 0) {
      set({ isGlobalCartLoading: true });
    }
  },

  stopLoading: (id: string) => {
    activeLoadingOperations.delete(id);

    // Clear existing timeout
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    if (activeLoadingOperations.size === 0) {
      // Hide loading with delay to prevent flicker
      timeoutId = setTimeout(() => {
        // Double check that no new operations started
        if (activeLoadingOperations.size === 0) {
          set({ isGlobalCartLoading: false });
        }
        timeoutId = null;
      }, 500);
    }
  }
}));
